package fr.arcplex.network

/**
 * Backend selection of the app. Swapping the backend later means replacing the
 * `SoonerApi` implementation behind this config, not touching the UI.
 */
data class NetworkConfig(
    val useCoherence: Boolean,
    val legacyBaseUrl: String = LEGACY_BASE_URL,
    val coherenceBaseUrl: String = defaultCoherenceBaseUrl,
    val apiKey: String = DEFAULT_API_KEY,
    /**
     * QA/dev escape hatch for the temporary TLS certificate the backend renews
     * monthly: when true, the JVM and Android clients trust any certificate and
     * skip hostname verification. Never enable it in production. Web targets
     * keep the browser TLS stack, so the flag has no effect there.
     */
    val allowInvalidCertificates: Boolean = insecureTlsRequestedByEnvironment()
) {
    companion object {
        /** Coherence API key (was duplicated between CoherenceApi and CoherenceTheme). */
        const val DEFAULT_API_KEY = "Tb3MDUpbNZ44SK6fzHBK6Qy2PYSJu-GcBedTf1YcrzU"
    }
}

/** Coherence API base URL; proxied through the web box on web platforms. */
expect val defaultCoherenceBaseUrl: String

/**
 * True when the QA/dev TLS escape hatch is requested by the environment:
 * `SOONERKMM_INSECURE_TLS=true` or `-Dsoonerkmm.insecureTls=true` on JVM/Android.
 * Always false on web, where TLS belongs to the browser.
 */
expect fun insecureTlsRequestedByEnvironment(): Boolean
